<section class="requerimento" data-testid="requerimento-online">
  @if (carregando()) {
    <app-empty-state message="Carregando a configuração do requerimento online…" />
  } @else {
    <div class="requerimento__cabecalho">
      <h2 class="requerimento__titulo">Configuração de Requerimento Online</h2>
      @if (status(); as statusAtual) {
        <vivest-tag type="status" [variant]="varianteStatus()" data-testid="requerimento-status">
          {{ statusAtual }}
        </vivest-tag>
      }
      @if (ultimaAtualizacao(); as data) {
        <span class="requerimento__atualizacao" data-testid="requerimento-ultima-atualizacao">
          Última atualização: {{ data }}
        </span>
      }
    </div>

    <form
      class="requerimento-form"
      [formGroup]="form"
      novalidate
      data-testid="requerimento-form"
      (ngSubmit)="salvar()"
    >
      <!-- Status e vigência -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="requerimento-bloco-status">
        <div class="requerimento-bloco">
          <h2 id="requerimento-bloco-status" class="requerimento-bloco__titulo">Status e vigência</h2>

          <div class="requerimento-vigencia">
            <vivest-select
              class="requerimento-campo"
              label="Status"
              name="status"
              status="default"
              error-message=""
              [options]="statusOpcoes"
              formControlName="status"
              data-testid="requerimento-status-config"
            ></vivest-select>

            <ng-container formGroupName="vigencia">
              <div class="requerimento-campo">
                <label class="campanha-form-label" for="requerimento-vigencia-inicio">
                  Início da vigência<span class="campanha-form-required" aria-hidden="true">*</span>
                </label>
                <input
                  id="requerimento-vigencia-inicio"
                  type="date"
                  class="form-control campanha-form-control"
                  formControlName="inicio"
                  required
                  [class.is-invalid]="vigencia.controls.inicio.touched && vigencia.controls.inicio.invalid"
                  data-testid="requerimento-vigencia-inicio"
                />
              </div>
              <div class="requerimento-campo">
                <label class="campanha-form-label" for="requerimento-vigencia-fim">Fim da vigência</label>
                <input
                  id="requerimento-vigencia-fim"
                  type="date"
                  class="form-control campanha-form-control"
                  formControlName="fim"
                  aria-describedby="requerimento-vigencia-dica"
                  [class.is-invalid]="vigencia.hasError('vigenciaIncoerente')"
                  data-testid="requerimento-vigencia-fim"
                />
              </div>
            </ng-container>
          </div>

          @if (vigencia.controls.inicio.touched && vigencia.controls.inicio.hasError('required')) {
            <p class="requerimento-erro" role="alert" data-testid="requerimento-erro-vigencia-inicio">
              Informe o início da vigência.
            </p>
          } @else if (vigencia.hasError('vigenciaIncoerente')) {
            <p class="requerimento-erro" role="alert" data-testid="requerimento-erro-vigencia">
              O fim da vigência não pode ser anterior ao início.
            </p>
          } @else {
            <p id="requerimento-vigencia-dica" class="requerimento-dica">
              Deixe o fim em branco para uma vigência sem data de término.
            </p>
          }
        </div>
      </vivest-card>

      <!-- Descrição -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="requerimento-bloco-descricao">
        <div class="requerimento-bloco">
          <h2 id="requerimento-bloco-descricao" class="requerimento-bloco__titulo">Descrição</h2>

          <div class="requerimento-campo">
            <label class="campanha-form-label" for="requerimento-descricao">Descrição</label>
            <textarea
              id="requerimento-descricao"
              class="form-control campanha-form-control campanha-form-textarea"
              rows="4"
              placeholder="Descreva o requerimento online"
              [attr.maxlength]="descricaoMaximo"
              formControlName="descricao"
              [class.is-invalid]="descricao.touched && descricao.invalid"
              aria-describedby="requerimento-descricao-contador"
              data-testid="requerimento-descricao"
            ></textarea>
            <p
              id="requerimento-descricao-contador"
              class="requerimento-dica requerimento-descricao__contador"
              data-testid="requerimento-descricao-contador"
            >
              {{ descricao.value.length }}/{{ descricaoMaximo }} caracteres
            </p>
          </div>
        </div>
      </vivest-card>

      <!-- Assinatura digital -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="requerimento-bloco-assinatura">
        <div class="requerimento-bloco" formGroupName="assinatura">
          <h2 id="requerimento-bloco-assinatura" class="requerimento-bloco__titulo">Assinatura digital</h2>

          <vivest-checkbox
            label-variant="multi-line"
            name="assinatura-obrigatoria"
            formControlName="obrigatoria"
            data-testid="requerimento-assinatura-obrigatoria"
          >
            Exigir assinatura digital
          </vivest-checkbox>

          <!-- Rótulo, placeholder, lista, estado desabilitado e erro vêm do vivest-select. -->
          <vivest-select
            class="requerimento-campo"
            label="Provedor"
            name="provedor"
            placeholder="Selecione o provedor"
            [options]="opcoesProvedor()"
            [status]="provedorComErro ? 'error' : 'default'"
            [attr.error-message]="provedorComErro ? 'Selecione o provedor da assinatura.' : ''"
            formControlName="provedor"
            data-testid="requerimento-provedor"
          ></vivest-select>

          <div class="requerimento-check-linha">
            <vivest-checkbox
              label-variant="multi-line"
              name="validacao-duas-etapas"
              formControlName="validacaoDuasEtapas"
              data-testid="requerimento-duas-etapas"
            >
              Validação em duas etapas
            </vivest-checkbox>
            <app-tooltip-ajuda
              rotulo="Sobre a validação em duas etapas"
              texto="Exige uma segunda confirmação do participante ao assinar os documentos."
              data-testid="requerimento-duas-etapas-ajuda"
            />
          </div>
        </div>
      </vivest-card>

      <!-- Documentos obrigatórios -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="requerimento-bloco-documentos">
        <div class="requerimento-bloco">
          <h2 id="requerimento-bloco-documentos" class="requerimento-bloco__titulo">Documentos obrigatórios</h2>
          <p class="requerimento-bloco__descricao" id="requerimento-documentos-descricao">
            Estes documentos serão pedidos ao participante no requerimento online. Desmarque um
            documento para tirá-lo da lista.
          </p>

          @if (documentos.length) {
            <!-- Desmarcado continua visível até salvar, para poder ser marcado de volta. -->
            <ul
              class="requerimento-documentos"
              formArrayName="documentos"
              aria-describedby="requerimento-documentos-descricao"
            >
              @for (documento of documentos.controls; track documento.controls.id.value; let i = $index) {
                <li
                  class="requerimento-documentos__item"
                  [class.requerimento-documentos__item--desmarcado]="!documento.controls.marcado.value"
                  [formGroupName]="i"
                >
                  <vivest-checkbox
                    label-variant="multi-line"
                    name="documentos-obrigatorios"
                    [value]="documento.controls.nome.value"
                    formControlName="marcado"
                    [attr.data-testid]="'requerimento-documento-' + i"
                  >
                    {{ documento.controls.nome.value }}
                  </vivest-checkbox>
                </li>
              }
            </ul>
          } @else {
            <p class="requerimento-documentos__vazio" data-testid="requerimento-documentos-vazio">
              Nenhum documento obrigatório. Use "Adicionar documento" para escolher os documentos
              pedidos ao participante.
            </p>
          }

          <vivest-button
            class="requerimento-adicionar"
            variant="outline"
            size="sm"
            data-testid="requerimento-adicionar-documento"
            (click)="abrirModalDocumentos()"
          >
            <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
            Adicionar documento
          </vivest-button>
        </div>
      </vivest-card>

      <footer class="requerimento-rodape">
        @if (form.dirty) {
          <span class="requerimento-rodape__aviso" data-testid="requerimento-alteracoes-pendentes">
            Há alterações não salvas
          </span>
        }
        <div class="requerimento-rodape__acoes">
          <!-- vivest-button renderiza um botão type="button": Salvar chama salvar() no clique. -->
          <vivest-button
            variant="outline"
            size="md"
            [disabled]="!form.dirty"
            data-testid="requerimento-cancelar"
            (click)="cancelar()"
          >
            Cancelar
          </vivest-button>
          <vivest-button
            variant="primary"
            size="md"
            [disabled]="salvando()"
            data-testid="requerimento-salvar"
            (click)="salvar()"
          >
            {{ salvando() ? 'Salvando…' : 'Salvar' }}
          </vivest-button>
        </div>
      </footer>
    </form>
  }

  <!--
    Confirmação antes de salvar (vivest-modal do design system). Fica sempre no DOM e abre por
    [open]; Esc (dismissible) e o fechamento nativo do <dialog> disparam vivest-close.
  -->
  <vivest-modal
    heading="Salvar configuração do requerimento online"
    description="Substituir a configuração do requerimento online? Status, vigência, assinatura e documentos desta tela passam a valer para o plano."
    [open]="confirmandoSalvar()"
    [hasIcon]="false"
    dismissible=""
    (vivest-close)="cancelarSalvar()"
    data-testid="requerimento-confirmar-salvar"
  >
    <vivest-button
      slot="actions"
      variant="outline"
      size="md"
      data-testid="requerimento-confirmar-voltar"
      (click)="cancelarSalvar()"
    >
      Voltar
    </vivest-button>
    <vivest-button
      slot="actions"
      variant="primary"
      size="md"
      data-testid="requerimento-confirmar-salvar-btn"
      (click)="confirmarSalvar()"
    >
      Salvar
    </vivest-button>
  </vivest-modal>

  @if (modalDocumentosAberto()) {
    <app-resgate-documentos-modal
      [opcoes]="documentosDisponiveis()"
      [jaIncluidos]="idsDocumentos()"
      [carregando]="carregandoDocumentos()"
      (adicionar)="adicionarDocumentos($event)"
      (fechar)="fecharModalDocumentos()"
    />
  }
</section>
